import type { Action } from '@atlassian/react-sweet-state';
import type { SelectedIssuesState } from './types';

export const actions = {
	insertSelectedIssueKey:
		(selectedIssueKey: string): Action<SelectedIssuesState> =>
		({ setState, getState }) => {
			const currentState = getState();
			const updatedSelectedIssueKeys = new Set(currentState.selectedIssueKeys);
			updatedSelectedIssueKeys.add(selectedIssueKey);

			setState({
				selectedIssueKeys: updatedSelectedIssueKeys,
			});
		},
	removeSelectedIssueKey:
		(selectedIssueKey: string): Action<SelectedIssuesState> =>
		({ setState, getState }) => {
			const currentState = getState();
			const updatedSelectedIssueKeys = new Set(currentState.selectedIssueKeys);
			updatedSelectedIssueKeys.delete(selectedIssueKey);

			setState({
				selectedIssueKeys: updatedSelectedIssueKeys,
			});
		},
} as const;
export type Actions = typeof actions;
